import { Box, Header, Text } from '@rbilabs/universal-components';

export const ReceiptHeadInfoContainer = Box;

export const ReceiptInfoLabel = Text.withConfig({
  variant: 'copyTwo',
  marginRight: '$1',
  alignSelf: 'flex-start',
});

export const ReceiptInfoDetail = Box.withConfig({
  flexShrink: 1,
});

export const ReceiptInfo = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  accessible: true,
  focusable: true,
});

export const Title = Header.withConfig({
  variant: 'headerFour',
  margin: 0,
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
});

export const ReceiptDate = ReceiptInfoLabel.withConfig({
  marginY: '$2',
});

export const ReceiptInfoDetailLabel = Text.withConfig({
  variant: 'copyTwo',
});
